/** Finds markup counted by lineClamp without backtracking over tag contents. */
const findHTMLTags = (text) => {
    const tokens = /<|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g;
    const matches = [];
    let match = tokens.exec(text);
    while (match) {
        if (match[0] === '<') {
            const closingIndex = text.indexOf('>', tokens.lastIndex);
            const end = closingIndex === -1 ? text.length : closingIndex + 1;
            matches.push(text.slice(match.index, end));
            tokens.lastIndex = end;
        }
        else {
            matches.push(match[0]);
        }
        match = tokens.exec(text);
    }
    return matches.length > 0 ? matches : null;
};

export { findHTMLTags };
